import { Tabs } from "antd";
import { DashboardLayout } from "components/layout/components/DashboardLayout";
import { Profile } from "./components/Profile";
import { Navbar } from "components/layout/components/Navbar";
import { Password } from "./components/Password";
import { Billings } from "./components/Billings";
import { NotificationSettings } from "./components/NotificationSettings";
import { TalentProfile } from "./components/talentProfile/TalentProfile";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { useLocation, useNavigate } from "react-router-dom";
import { TalentCertifications } from "./components/talentProfile/TalentCertifications";
import { TalentProjects } from "./components/talentProfile/TalentProjects";
import { TalentURLs } from "./components/talentProfile/TalentURLs";
import { TalentInterests } from "./components/talentProfile/TalentInterests";
import { TalentExperience } from "./components/talentProfile/TalentExperience";
import { TalentEducation } from "./components/talentProfile/TalentEducation";
import { ProfileCompany } from "./components/ProfileCompany";
import { ProfileCompanySettings } from "./components/ProfileCompanySettings";
import { routePath } from "config/routeMgt/routePath";

export const Settings = () => {
  const { userInfo } = useGetUserInfo();
  const location = useLocation();
  const navigate = useNavigate();

  const isTalent = userInfo?.type === "talent";

  const getKeyFromPath = (pathname: string) => {
    switch (pathname) {
      case routePath.profile: return '1';
      case routePath.profileCompany: return '2';
      case routePath.profileCompanySettings: return '2';
      case routePath.education: return '1';
      case routePath.documents: return '3';
      case '/settings/personality-test': return '5';
      case routePath.password: return '6';
      case routePath.billings: return '7';
      case routePath.notifications: return '8';
      default: return '1';
    }
  };

  const getPathFromKey = (key: string) => {
    switch (key) {
      case '1': return routePath.profile;
      case '2': return routePath.profileCompany;
      case '3': return '/settings/documents';
      case '5': return '/settings/personality-test';
      case '6': return routePath.password;
      case '7': return routePath.billings;
      case '8': return routePath.notifications;
      default: return routePath.profile;
    }
  };

  const activeTabKey = getKeyFromPath(location.pathname);

  const handleTabChange = (key: string) => {
    navigate(getPathFromKey(key));
  };
  const profileTabs = (key: string) => {
    switch(key){
      case routePath.education: return <TalentEducation />;
      case routePath.experience: return <TalentExperience />;
      case routePath.urls: return <TalentURLs />;
      case routePath.interests: return <TalentInterests />;
      case routePath.certifications: return <TalentCertifications />;
      case routePath.projects: return <TalentProjects />;
      default: return <TalentProfile />
    }
  };

  return (
    <DashboardLayout>
      {isTalent ? (
        <Navbar title="My Profile" description="" />
      ) : (
        <Navbar title="Settings" description="" />
      )}
      <Tabs activeKey={activeTabKey} onChange={handleTabChange} size="large">
        <Tabs.TabPane tab="Profile" key="1">
          {isTalent ? (
            profileTabs(location.pathname)
          ) : (
            <Profile />
          )}
        </Tabs.TabPane>
        {!isTalent && (
          <Tabs.TabPane tab="Company Details" key="2">
            <ProfileCompanySettings />
          </Tabs.TabPane>
        )}

        <Tabs.TabPane tab="Password" key="6">
          <Password />
        </Tabs.TabPane>

        {!isTalent && (
          <Tabs.TabPane tab="Notifications" key="8">
            <NotificationSettings />
          </Tabs.TabPane>
        )}

        {!isTalent && userInfo?.recruiter?.parent_id == null && userInfo?.current_team === undefined && (
          <Tabs.TabPane tab="Plans and Billings" key="7">
            <Billings />
          </Tabs.TabPane>
        )}
      </Tabs>
    </DashboardLayout>
  );
};